import { Behavior } from "../Behavior";
import type { IGrid } from "../types";
import type { Particle } from "../Particle";

export type ParticleFactory = () => Particle;

export interface PhaseRule {
    temp: number;
    type: 'above' | 'below';
    factory: ParticleFactory;
    probability?: number;
}

export class PhaseChange extends Behavior {
    rules: PhaseRule[];

    constructor(rules: PhaseRule[]) {
        super();
        this.rules = rules;
    }

    update(particle: Particle, grid: IGrid, index: number) {
        for (const rule of this.rules) {
            let triggered = false;
            if (rule.type === 'above' && particle.temperature >= rule.temp) {
                triggered = true;
            } else if (rule.type === 'below' && particle.temperature <= rule.temp) {
                triggered = true;
            }

            if (triggered) {
                // 如果定义了概率，则进行随机判定
                if (rule.probability !== undefined && Math.random() > rule.probability) {
                    continue;
                }
                const newParticle = rule.factory();
                grid.setIndex(index, newParticle);
                return index;
            }
        }
    }
}
